export default __webpack_public_path__ + "static/media/gcp.89993b8e.svg";